const PATHNAME = window.location.pathname
const ISQA = PATHNAME.includes('qa');
export const API_HOST = process.env.NODE_ENV === 'production' && !ISQA? 'http://bg.fjyszn.com/' : 'http://bg.fjyszn.com/qa'
// export const API_HOST = process.env.NODE_ENV === 'production' && !ISQA? 'http://bg1.fjyszn.com/' : 'http://bg1.fjyszn.com/qa'
